import { Button, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useRouteError } from 'react-router';
import * as Sentry from '@sentry/react';

export default () => {
  const error = useRouteError();

  useEffect(() => {
    console.error(error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <Stack
      sx={{
        alignItems: 'center',
        mt: 8,
      }}
    >
      <Typography
        variant="h1"
        component="h1"
        sx={{
          fontWeight: 'bold',
        }}
      >
        500!
      </Typography>
      <Typography variant="h3" component="h3">
        Server or client error occurred
      </Typography>
      <Typography
        variant="body1"
        component="p"
        sx={{
          textAlign: 'center',
          mt: 2,
        }}
      >
        Sorry, it seems that you found a bug. <br />
      </Typography>
      <Button onClick={() => window.location.reload()}>Refresh page</Button>
    </Stack>
  );
};
